import { DateObjectUnits, PossibleDaysInMonth, DateTime as dt } from 'luxon'
import { first, isEqual, map, range } from 'lodash'
import type { CalendarDate } from '../views/WorkOrderCalendar/WorkOrderCalendar.slice'

const workOrderCalendar = {
  getCurrentMonthAndYear () {
    const now = dt.now()
    return {
      month: now.get('month'),
      year: now.get('year')
    }
  },

  getNextMonthAndYear (
    month: DateObjectUnits['month'],
    year: DateObjectUnits['year']
  ) {
    const date = dt.now().set({ month }).set({ year }).plus({ month: 1 })
    return {
      month: date.get('month'),
      year: date.get('year')
    }
  },

  getPreviousMonthAndYear (
    month: DateObjectUnits['month'],
    year: DateObjectUnits['year']
  ) {
    const date = dt.now().set({ month }).set({ year }).minus({ month: 1 })
    return {
      month: date.get('month'),
      year: date.get('year')
    }
  },

  getDatesInitialData (
    month: DateObjectUnits['month'],
    year: DateObjectUnits['year']
  ): (CalendarDate | null)[] {
    const now = dt.now().set({ month, year })
    const daysInMonth = now.daysInMonth as PossibleDaysInMonth
    const days = range(1, daysInMonth + 1)
    const dates: CalendarDate[] = map(days, day => {
      const date = now.set({ day })
      return {
        day: date.get('day'),
        date: date.toUTC().toString(),
        workOrders: [],
        week: {
          name: date.get('weekdayShort').toString(),
          day: date.get('weekday')
        }
      }
    })
    const firstDate = first(dates) as NonNullable<CalendarDate>
    const appendsCount = firstDate.week.day === 7 ? 0 : firstDate.week.day
    const holderDates = (count: number) => Array(count).fill(null)
    const prependsCount = (7 * 6) - (appendsCount + dates.length)
    return [
      ...holderDates(appendsCount),
      ...dates,
      ...holderDates(prependsCount)
    ]
  },

  getMonthName (month: DateObjectUnits['month']) {
    return dt.now().set({ month }).get('monthLong')
  },

  getStartAndEndDatesFromMonthAndYear (
    month: DateObjectUnits['month'],
    year: DateObjectUnits['year']
  ) {
    const firstDate = dt.fromObject({ day: 1, month, year })
    return {
      start: firstDate.toUTC().toString(),
      end: firstDate.endOf('month').toUTC().toString()
    }
  },

  isDatesEqual (firstDate: string, secondDate: string) {
    const dateData = (date: string) => {
      const dateObj = dt.fromISO(date)
      return {
        day: dateObj.get('day'),
        month: dateObj.get('month'),
        year: dateObj.get('year')
      }
    }
    return isEqual(dateData(firstDate), dateData(secondDate))
  },

  isDateToday (date: string) {
    return this.isDatesEqual(dt.now().toUTC().toString(), date)
  },

  getProduceAtDateOnly (date: string) {
    return dt.fromISO(date).toUTC().toISODate()
  }
}

export default workOrderCalendar
